<input type="checkbox" #notification kendoCheckBox [checked]="checked"/>
<kendo-label
  class="k-checkbox-label"
  [for]="notification"
>
  <small>{{ refNumber + 1}} = {{ doDescription.description }} [ {{ doDescription.department }} ] </small>
</kendo-label>

